import $ from 'jquery';
window.$ = window.jQuery = $;
import 'jquery-validation';
import axios from 'axios';
import {closeModal, turnOffScrollbar, turnOnScrollbar} from "./header.js";
import airports from "../airports.min.json";
import select2 from "select2";
import "select2/dist/css/select2.css";

import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";

select2($);
const formInit = () => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] =
        document.querySelector('meta[name="csrf-token"]')?.content ?? '';
    axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

    $(document).off('click', '[data-submit]').on('click', '[data-submit]', function () {
        const $form = $(this).closest('form');
        const handler = $form.data('submitHandler');
        if (typeof handler === 'function') {
            handler();
        }
    });

    const $feedbackModal = $("#feedback-modal");
    const $feedbackInModal = $('#feedback-in-modal')
    const $bgShadow = $('.bg-shadow');

    const simpleFormInit = (formSelector, isInModal, hasErrorMessages = true, isRedirect = false) => {
        const $form = $(formSelector);
        if (!$form.length) return;

        $(formSelector + ' .form__input').on('input', function () {
            $(this).closest('.input__wrapper').removeClass('error');
        });

        const validator = $form.validate({
            errorPlacement: function (error, element) {
                let $target = element.closest(".input__wrapper").addClass('error');
                if (hasErrorMessages)
                    $target.find(".error__message").text(error.text());
            }
        });

        const submitHandler = () => {
            if (!$form.valid()) return;

            const action = $form[0].action;
            let formData = new FormData($form[0]);
            $form.addClass('loading');

            axios.post(action, formData)
                .then(response => {
                    clearErrorClass();
                    $form[0].reset();
                    resetAirports($form);
                    if (isRedirect) {
                        window.location.href = response.data.redirect;
                        return;
                    }
                    let message = response.data.message;
                    const defaultMessage = 'Great, we received your quote request. Our specialist will contact you in 15 minutes.';
                    if (isInModal) {
                        showFeedbackInModal(true, message || defaultMessage);
                    } else {
                        showModal(true, message || defaultMessage);
                    }
                })
                .catch(response => {
                    if (response.response?.status === 419) {
                        fetch(window.location.href)
                            .then(r => r.text())
                            .then(html => {
                                const doc = new DOMParser().parseFromString(html, 'text/html');
                                const newToken = doc.querySelector('meta[name="csrf-token"]')?.content;
                                if (newToken) {
                                    document.querySelector('meta[name="csrf-token"]').content = newToken;
                                    axios.defaults.headers.common['X-CSRF-TOKEN'] = newToken;
                                    submitHandler();
                                }
                            });
                        return;
                    }
                    if (response.response?.status === 422) {
                        let errors = response.response.data.errors;
                        validator.resetForm();
                        validator.showErrors(errors);
                        return;
                    }
                    let message = response.response?.data?.message;
                    const defaultMessage = 'Looks like something went wrong! Please try again later.';
                    if (isInModal) {
                        showFeedbackInModal(false, message || defaultMessage);
                    } else {
                        showModal(false, message || defaultMessage);
                    }
                })
                .finally(() => {
                    $form.removeClass('loading');
                });
        };

        $form.data('submitHandler', submitHandler);
    };

    function clearErrorClass(){
        $('.error').removeClass('has--error')
    }

    function showModal(isSuccess, message){
        let className = isSuccess ? 'success' : 'fail';
        let messageSelector = isSuccess ? '.success-message' : '.fail-message';
        $feedbackModal
            .addClass('modal-opened')
            .find('.feedback')
            .removeClass('success')
            .removeClass('fail')
            .addClass(className)
            .find(messageSelector)
            .html(message);
        if (window.innerWidth > 767)
            $feedbackModal.fadeIn(300);
        else
            $feedbackModal.slideDown(300);
        $bgShadow.fadeIn(300);
        turnOffScrollbar();
    }

    function showFeedbackInModal(isSuccess, message){
        let className = isSuccess ? 'success' : 'fail';
        let messageSelector = isSuccess ? '.success-message' : '.fail-message';
        $feedbackInModal.addClass('in-modal-opened')
            .find('.feedback')
            .removeClass('success')
            .removeClass('fail')
            .addClass(className)
            .find(messageSelector)
            .html(message);
        $feedbackInModal.fadeIn(300);
    }

    const formElementsInit = () => {
        // let calendar = flatpickr("#dateInput");

        const $bgShadow = $('.bg-shadow');

        let $flightTypeSelect = $('.flight-type-select select').select2({
            minimumResultsForSearch: Infinity,
            dropdownCssClass: "simple-dropdown",
            dropdownParent: $('#flight-type__dropdown .flight-type__dropdown-body'),
            closeOnSelect: false
        });

        $flightTypeSelect.select2('open');
        let $flyTypeDropdown = $('#flight-type__dropdown');

        $flightTypeSelect.on('select2:closing', function (e) {
            e.preventDefault();
        });

        $flightTypeSelect.on('select2:close', function (e) {
            e.preventDefault();
        });

        $flightTypeSelect.on('select2:select', function (e){
            if (window.innerWidth >= 768){
                $flyTypeDropdown.fadeOut(300).removeClass('modal-opened');
            }else {
                $flyTypeDropdown.slideUp(300).removeClass('modal-opened');
                $bgShadow.fadeOut(300);
                turnOnScrollbar();
            }
        })
    }

    function resetAirports($form){
        $form.find('select:not(#flight-type)').val(null).trigger('change');
        $('.select2-search__field').val(null).trigger('change');
        $('.select2-results__option--selected').removeClass('select2-results__option--selected');

    }

    function initiateFlatPikr(elementId, parentElem){
        return flatpickr(elementId, {
            dateFormat: "d/m/Y",
            appendTo: parentElem,
            minDate: "today",
            inline: true,
            locale: {
                firstDayOfWeek: 1,
                weekdays: {
                    shorthand: [ "Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
                    longhand: [
                        "Sunday", "Monday", "Tuesday", "Wednesday",
                        "Thursday", "Friday", "Saturday",
                    ]
                }
            },
            nextArrow: '<svg xmlns="http://www.w3.org/2000/svg" style="transform: scaleX(-1)" width="8" height="14" viewBox="0 0 8 14" fill="none">\n' +
                '<path d="M7 1L1 7L7 13" stroke="#262636" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>\n' +
                '</svg>',
            prevArrow: '<svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none">\n' +
                '<path d="M7 1L1 7L7 13" stroke="#262636" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>\n' +
                '</svg>',

            disableMobile: true,
            monthSelectorType: "static", // важно: делает месяц текстом, а не select
            onReady: function (selectedDates, dateStr, instance) {
                updateHeader(instance);
            },
            onMonthChange: function (selectedDates, dateStr, instance) {
                updateHeader(instance);
            },
            onYearChange: function (selectedDates, dateStr, instance) {
                updateHeader(instance);
            },
            onOpen: function(selectedDates, dateStr, instance) {
                if(window.innerWidth < 768){
                    $(instance).slideUp(200).addClass('modal-opened')
                }
            },
            onClose: function(selectedDates, dateStr, instance) {
                if(window.innerWidth < 768){
                    $(instance).slideDown(200).addClass('modal-opened')
                }
            },
            onChange: function(selectedDates, dateStr, instance) {
                let $modal = $(parentElem).closest('.calendar-mobile');
                closeModal($modal);
            }
        });
    }
    function updateHeader(instance) {
        const monthYearContainer = instance.calendarContainer.querySelector(".flatpickr-current-month");
        if (!monthYearContainer) return;

        monthYearContainer.innerHTML = "";

        const label = document.createElement("span");
        label.className = "flatpickr-month-year";
        label.textContent = instance.formatDate(
            new Date(instance.currentYear, instance.currentMonth),
            "F, Y"
        );

        monthYearContainer.appendChild(label);
    }

    function initializeAirportSearch(selector, $parent){
        let $airportSearchSelect = $(selector).select2({
            placeholder: "City/Airport",
            minimumInputLength: 2,
            dropdownCssClass: "dropdown-search",
            dropdownParent: $parent,

            ajax: {
                transport: function (params, success, failure) {
                    const qRaw = (params.data.q || '').trim();
                    if (!qRaw) return success({ results: [] });

                    // IATA в верхний регистр, текст в нижний
                    const qIATA = qRaw.toUpperCase();
                    const qText = qRaw.toLowerCase();

                    const eqU     = (s) => s === qIATA;
                    const startsU = (s) => s.startsWith(qIATA);

                    const eq      = (s) => s === qText;
                    const starts  = (s) => s.startsWith(qText);

                    // скоринг: exact выше starts; приоритет IATA > city > name
                    function score(a) {
                        const iata = (a.iata || '').toUpperCase();
                        const city = (a.city || '').toLowerCase();
                        const name = (a.name || '').toLowerCase();

                        let s = -1;

                        // exact
                        if (eqU(iata)) s = Math.max(s, 9000);
                        if (eq(city))  s = Math.max(s, 8000);
                        if (eq(name))  s = Math.max(s, 7000);

                        // startsWith (никаких includes!)
                        if (startsU(iata)) s = Math.max(s, 6000);
                        if (starts(city))  s = Math.max(s, 5000);
                        if (starts(name))  s = Math.max(s, 4000);

                        // лёгкий тай-брейкер
                        s -= Math.min(name.length, 60) * 0.01;
                        return s;
                    }

                    // фильтр: только exact/starts по iata/city/name (без подстрок)
                    const matched = airports.filter(a => {
                        const iata = (a.iata || '').toUpperCase();
                        const city = (a.city || '').toLowerCase();
                        const name = (a.name || '').toLowerCase();

                        return (
                            eqU(iata) || startsU(iata) ||
                            eq(city)  || starts(city)  ||
                            eq(name)  || starts(name)
                        );
                    });

                    matched.sort((a, b) => {
                        const sa = score(a);
                        const sb = score(b);
                        if (sb !== sa) return sb - sa;

                        const iA = (a.iata || '').toUpperCase();
                        const iB = (b.iata || '').toUpperCase();
                        if (iA !== iB) return iA.localeCompare(iB);

                        const cA = (a.city || '').toLowerCase();
                        const cB = (b.city || '').toLowerCase();
                        return cA.localeCompare(cB);
                    });

                    const results = matched.slice(0, 100).map(a => ({
                        id: a.city + '_' + a.iata + '_' + a.country,
                        city: a.city,
                        country: a.country,
                        iata: a.iata,
                        name: a.name
                    }));

                    success({ results });
                },
                delay: 250
            },
            escapeMarkup: function (markup) { return markup; },
            width: '100%',
            templateResult: function (airport) {
                if (!airport.id) return airport.text; // placeholder
                return `
            <div class="airport-result">
                <div class="airport-position">
                    <span class="airport-city">${airport.name}</span>
                    <span class="airport-country">${airport.city}</span>
                </div>
                <span class="country-code">(${airport.iata})</span>
            </div>
        `;
            },

            templateSelection: function (airport) {
                if (!airport.id) return airport.text;
                if(!(airport.city && airport.name)){
                    const foundedAirport = airports.find(a => (a.city + '_' + a.iata + '_' + a.country) === airport.id);
                    if (foundedAirport){
                        airport.city = foundedAirport.city;
                        airport.name = foundedAirport.name;
                    }
                }
                return `<span class="airport-selected">${airport.city? airport.city + " /" : ''} ${airport.name}</span>`;
            },
        });

        $airportSearchSelect.select2('open');

        let $modal = $parent.closest('.airport-search-mobile')
        $airportSearchSelect.off('select2:select').on('select2:select', function (e) {
            closeModal($modal);
        });
        $modal.off('click').on('click', '.select2-results__option--selected', function (e) {
            closeModal($modal);
        });

        $airportSearchSelect.on('select2:closing', function (e) {
            e.preventDefault();
        });

        $airportSearchSelect.on('select2:close', function (e) {
            e.preventDefault();
        });

        const defaultValue = $airportSearchSelect.data('selected-default'); // строка вида "City_IATA_COUNTRY"
        if (defaultValue) {
            const defaultAirport = airports.find(a => (a.city + '_' + a.iata + '_' + a.country) === defaultValue);
            if (defaultAirport) {
                const optionText = `${defaultAirport.city} (${defaultAirport.iata})`;
                const option = new Option(optionText, defaultValue, true, true);

                $(option)
                    .attr('data-city', defaultAirport.city)
                    .attr('data-iata', defaultAirport.iata)
                    .attr('data-country', defaultAirport.country);
                $airportSearchSelect.append(option);

                $airportSearchSelect.val(defaultValue).trigger('change.select2');
                setTimeout(() => {
                    $airportSearchSelect.closest('.input__wrapper')
                        .find('.select2-container .airport-selected')
                        .text((defaultAirport.city? defaultAirport.city + " / " : '') + defaultAirport.name);
                }, 0);
            }
        }
    }

    return {
        simpleFormInit,
        formElementsInit,
        initiateFlatPikr,
        initializeAirportSearch
    };
}

export default formInit;
